import React from "react";
import { ShimmerEffect } from "components/shimmer";

export default function FolderGridSkeleton({ count = 20 }) {
  return (
    <div className="px-4 grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-5 xl:grid-cols-6">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="flex flex-col">
          <div className="aspect-square bg-muted border border-border rounded-lg overflow-hidden flex items-center justify-center">
            <ShimmerEffect className="size-10 rounded-full" />
          </div>
          <div className="p-4 border-b border-border flex-1">
            <ShimmerEffect className="h-4 w-3/4 rounded" />
            <ShimmerEffect className="h-4 w-1/2 rounded mt-2" />
          </div>
        </div>
      ))}
    </div>
  );
}
